<div class="evi">
  <header class="evi__header">
    <div class="evi__header-title">
      <!-- <img src="/assets/icn/evi.svg" class="icon icon--evi"> -->
      <div class="evi__header-title-icon" id="evi-header-icon">
        <div class="evi-icon">
          <ng-lottie [options]="options"></ng-lottie>
        </div>
        <!--
        or if speaking to agent, show agent avatar
        <img src="/assets/img/avatar-confetti-happy@2x.png" class="icon icon--agent">
        -->
      </div>

      <p class="evi__header-title-min" data-toggle="evi-minmax" id="demo-evi-title-min"
        (click)="initEvi()?.eviMinMaxToggle()">
        {{chats.length > 0 ? "Ongoing chat with Evi" : person ? "Hi "+person?.first_name+", I'm Evi, ask me
        about insurance" : '' }}
      </p>
      <p class="evi__header-title-max" id="demo-evi-title-max">Chat with Evi</p>
    </div>
    <div class="evi__header-actions">
      <div class="evi__header-minmax" data-toggle="evi-minmax" (click)="initEvi()?.eviMinMaxToggle()">
        <svg class="icon">
          <use xlink:href="#chevron-up"></use>
        </svg>
        <svg class="icon">
          <use xlink:href="#minimiza"></use>
        </svg>
      </div>
      <div class="evi__header-close" data-dismiss="evi" (click)="closeEvi()">
        <svg class="icon">
          <use xlink:href="#close-medium"></use>
        </svg>
      </div>
    </div>
  </header>
  <div class="evi__body">
    <div class="evi__content">

      <!-- evi -->

      @for (chat of chats; track chat.chat_index; let i = $index) {
        <div [ngClass]="chat?.reaction ? 'evi__message--reacted':''"
          [ngClass]="chats?.length == (i+1) ? 'evi__message--latest-response':''"
          class="evi__message evi__message--{{chat.chat_type}}"
          [id]="'evi__message-'+chat.chat_type+'-'+chat.chat_index">
          @if (chat.chat_type === 'response') {
            <div class="evi__message-avatar">
              @if (chats?.length == (i+1)) {
                <div class="evi-icon evi-icon--lg">
                  <ng-lottie [options]="options"></ng-lottie>
                </div>
              }
            </div>
          }
          @if (chat.chat_text !== '') {
            <div class="evi__message-content">
              <p [innerHTML]="chat.chat_text"></p>
            </div>
          }
          <!-- <a href="javascript:;" class="evi__message-action" (click)="initAIModal(event, 'conflicting-info')" data-dismiss="evi">
          <p>I’m happy to proceed with the one policy schedule</p>
        </a> -->
        @if (chat.file_path && chat.file_path !== '') {
          <div class="evi__message-control">
            <div class="custom-upload__wrap dz-processing dz-success dz-complete">
              <div class="custom-upload__icon">
                <svg class="icon icon--success">
                  <use xlink:href="#complete"></use>
                </svg>
              </div>
              <div class="custom-upload__filename">
                <a href="{{baseurl + chat.file_path}}" target="_blank">{{ chat.file_path }}</a>
              </div>
              <div class="custom-upload__control">
                <svg class="icon icon--success">
                  <use xlink:href="#trash-bin"></use>
                </svg>
              </div>
            </div>
          </div>
        }
        @if (chat.chat_type === 'response') {
          <div class="evi__message-reaction">
            <svg (click)="setReaction(chat,1)" [ngClass]="chat?.reaction == 1 ? 'is-active':''"
              class="icon icon--sm icon--positive">
              <use xlink:href="#thumb-up"></use>
            </svg>
            <svg (click)="setReaction(chat,0)" [ngClass]="chat?.reaction == 0 ? 'is-active':''"
              class="icon icon--sm icon--negative">
              <use xlink:href="#thumb-down"></use>
            </svg>
          </div>
        }
      </div>
    }
    <!-- <div class="evi__message-content d-none" id="evi-upload-text">
    <p>Upload your schedule and skip straight to your personalised quote.</p>
  </div> -->

  <div id="bottom"></div>

  @if (!termsAccepted) {
    <div class="evi__message evi__message--response" id="evi-msg-3">
      <div class="evi__message-avatar">
        <div class="evi-icon">
          <lottie-player src="/assets/evi-icon.json" background="transparent" speed="1" loop=""
          autoplay=""></lottie-player>
        </div>
      </div>
      <div class="evi__message-content">
        <p>Before we get started, please take a moment to review our <a
          href="https://vader.everything.insure/ei_chatbot_terms.pdf" target="_blank">Terms and
        Conditions</a>. By
      clicking "Accept," you agree to them and can start chatting with Evi.</p>
    </div>
    <div class="evi__message-action">
      <svg class="icon icon--sm">
        <use xlink:href="#complete"></use>
      </svg>
      <p><a href="javascript:;" (click)="acceptTerms()">Accept</a></p>
    </div>
  </div>
}




<div class="evi__message-control" id="evi-upload"
  [class.d-none]="!showUploadSection || !uploadDisclaimerAccepted">
  <div class="custom-upload custom-upload--sm eviUploaderSelector" id="customUploadDocs">
    <div class="custom-upload__dropzone dz-default">
      <div class="custom-upload__thumb">
        <img src="assets/img/upload.svg" />
      </div>
      <div class="custom-upload__instructions">
        <p>Tap to add files</p>
        <svg class="icon">
          <use xlink:href="#upload"></use>
        </svg>
        <p>Drag and drop a file here or <strong>click here</strong> to upload your files</p>
        <div class="custom-upload__note">
          <p><small>Accepts pdf. Maximum size 10MB</small></p>
        </div>
      </div>
    </div>
    <div class="fallback">
      <input type="file" name="file" multiple />
    </div>
  </div><br>
</div>
@if (jobStatus?.status && uploadDisclaimerAccepted) {
  <div
    class="evi__message evi__message--response evi__message--latest-response">
    <div class="evi__message-avatar">
      <div class="evi-icon evi-icon--lg">
        <ng-lottie [options]="options"></ng-lottie>
      </div>
    </div>
    @if (jobStatus?.status) {
      <div class="evi__message-content">
        <p [innerHTML]="jobStatus?.message"></p>
      </div>
    }
  </div>
}
<!-- PDF password prompt -->
@if (pdfPasswordRequired) {
  <div class="evi__message evi__message--response evi__message--latest-response">
    <div class="evi__message-avatar">
      <div class="evi-icon evi-icon--lg">
        <ng-lottie [options]="options"></ng-lottie>
      </div>
    </div>
    <div class="evi__message-content">
      @if (PDF_PASSWORD_MAX_ATTEMPTS === 0 || pdfPasswordAttempts < PDF_PASSWORD_MAX_ATTEMPTS) {
        <p>{{ pdfPasswordMessage }}</p>
      }
      @if (PDF_PASSWORD_MAX_ATTEMPTS > 0 && pdfPasswordAttempts >= PDF_PASSWORD_MAX_ATTEMPTS) {
        <p>Maximum password attempts reached. Please re-upload your file.</p>
      }
    </div>
    @if (PDF_PASSWORD_MAX_ATTEMPTS === 0 || pdfPasswordAttempts < PDF_PASSWORD_MAX_ATTEMPTS) {
      <div class="evi__message-control">
        <div class="input-group">
          <input [type]="pdfPasswordVisible ? 'text' : 'password'" class="form-control" [(ngModel)]="pdfPassword" placeholder="Enter PDF password" (keydown.enter)="submitPdfPassword()">
          <div class="input-group-append">
            <span class="input-group-icon input-group-icon--password">
              <a href="javascript:;" (click)="pdfPasswordVisible = !pdfPasswordVisible">
                <svg class="icon">
                  <use [attr.xlink:href]="pdfPasswordVisible ? '#eye-off' : '#eye'"></use>
                </svg>
              </a>
            </span>
          </div>
          <button class="button button--everything" style="margin-left:0.75rem;" (click)="submitPdfPassword()">Submit</button>
        </div>
      </div>
    }
  </div>
}

<!-- Post-upload disclaimer - shown after file is uploaded, must be accepted before proceeding -->
@if (termsAccepted && jobStatus?.status && !uploadDisclaimerAccepted && !pdfPasswordRequired) {
  <div
    class="evi__message evi__message--response">
    <div class="evi__message-avatar">
      <div class="evi-icon evi-icon--lg">
        <ng-lottie [options]="options"></ng-lottie>
      </div>
    </div>
    <div class="evi__message-content">
      <p>Please take note that the quote provided is based on the information contained in the policy
        schedule that you have uploaded. It is important that you ensure that all information contained
        in the policy schedule that you uploaded is true, correct and accurate. Everything Insure
        Digital Intermediaries is not liable for any errors in the information contained in the policy
      schedule that you uploaded.</p>
    </div>
    <div class="evi__message-action">
      <svg class="icon icon--sm">
        <use xlink:href="#complete"></use>
      </svg>
      <p><a href="javascript:;" (click)="uploadDisclaimerAccepted = true">Accept</a></p>
    </div>
  </div>
}
<!-- Proceed button - visible once job is ready and upload disclaimer accepted -->
@if (jobStatus?.status === 'ready' && uploadDisclaimerAccepted) {
  <a href="javascript:;"
    class="evi__message-action" (click)="initEvi()?.eviClose(); initAIModal($event, 'conflicting-info');">
    <p>I'm happy to proceed with the one policy schedule</p>
  </a>
}

</div>

<div class="evi__input" id="evi-inputwrap">

  @if (termsAccepted && (!jobStatus?.status || (jobStatus?.status === 'ready' && uploadDisclaimerAccepted))) {
    <textarea class="form-control" rows="1" placeholder="" id="evi-input"
    (keydown)="checkEnter($event)"></textarea>
    <button type="submit" class="button button--everything" (click)="sendRequest()" id="evi-submit">
      <svg class="icon">
        <use xlink:href="#arrow-down"></use>
      </svg>
    </button>
  }
</div>
<div class="evi__thinking d-none" id="evi-thinking">
  <div><span></span></div>
</div>
<div class="evi__tags" id="evi-tags">
  <ul>
    <li><a href="https://vader.everything.insure/ei_chatbot_terms.pdf" target="_blank">Terms and
    Conditions</a> </li>
    <!-- <li>Show me more options</li>
    <li>Which is best for my family</li> -->
  </ul>
</div>
</div>
</div>
<div class="evi-backdrop" (click)="initEvi()?.eviClose()"></div>
<div class="ai-modal">
  <div class="ai-modal__dialog">
    <div class="ai-modal__body">

      <div class="ai-modal__nav d-none" id="demo-ai-modal-nav">

        <div class="ai-modal__nav-title">
          <button class="ai-modal__nav-title-back" id="demo-ai-modal-back-btn">
            <svg class="icon">
              <use xlink:href="#arrow-left-small"></use>
            </svg>
          </button>
          <h6>Back</h6>
        </div>

      </div>

      <div class="ai-modal__inner">
        <div class="ai-modal__sidebar">
          <div class="ai-modal__sidebar-topnav">

            <ul class="list-unstyled" id="demo-ai-modal-infonav">
              <li>
                <a href="#savequote-modal" data-toggle="modal">
                  <svg class="icon">
                    <use xlink:href="#bookmark"></use>
                  </svg>
                  <span>Save</span>
                </a>
              </li>
            </ul>

            <ul class="list-unstyled d-none" id="demo-ai-modal-reviewnav">
              <li>
                <a href="javascript:;"
                  (click)="initAIModal(null,null)?.openAIModalItems($event, 'review-details-nav')"
                  id="demo-ai-modal-reviewnav-profile">
                  <svg class="icon">
                    <use xlink:href="#profile"></use>
                  </svg>
                  <span>Details</span>
                </a>
              </li>
              <li>
                <a href="javascript:;"
                  (click)="initAIModal(null,null)?.openAIModalItems($event, 'review-insured-items-nav')"
                  id="demo-ai-modal-reviewnav-items">
                  <svg class="icon">
                    <use xlink:href="#insured-items"></use>
                  </svg>
                  <span>Items</span>
                </a>
              </li>
              <li><!-- empty li for divider (no whitespace) --></li>
              <li>
                <a href="#savequote-modal" data-toggle="modal">
                  <svg class="icon">
                    <use xlink:href="#bookmark"></use>
                  </svg>
                  <span>Save</span>
                </a>
              </li>
            </ul>
            <ul class="list-unstyled d-none" id="demo-ai-modal-addnav">
              <li class="is-active">
                <a href="javascript:;"
                  (click)="initAIModal(null,null)?.openAIModalItems($event, 'add-benefits-nav')"
                  id="demo-ai-modal-addnav-benefits">
                  <svg class="icon">
                    <use xlink:href="#benefit-add"></use>
                  </svg>
                  <span>Benefits</span>
                </a>
              </li>
              <li>
                <a href="javascript:;" onclick="openAIModalAddItemsFlow(event)"
                  id="demo-ai-modal-addnav-items">
                  <svg class="icon">
                    <use xlink:href="#insured-items-add"></use>
                  </svg>
                  <span>Items</span>
                </a>
              </li>
              <li><!-- empty li for divider (no whitespace) --></li>
              <li>
                <a href="#savequote-modal" data-toggle="modal">
                  <svg class="icon">
                    <use xlink:href="#bookmark"></use>
                  </svg>
                  <span>Save</span>
                </a>
              </li>
            </ul>


          </div>
          <div class="ai-modal__sidebar-bottomnav">
            <ul class="list-unstyled">
              <li>
                <a href="javascript:;" (click)="openSidesheet()" data-sidesheet-trigger="help">
                  <svg class="icon">
                    <use xlink:href="#help-Icon"></use>
                  </svg>
                  <span>Help</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="ai-modal__main">
          <div class="ai-modal__content">

            <div class="ai-modal__content-questions" id="demo-ai-content-questions">

              <div class="container layout layout--questions">

                <div class="layout__main in">

                  <div class="question-heading">
                    <div class="question-heading__avatar">
                      <img src="assets/0/avatar/blank.png" class="img-fluid" alt="">
                      <div class="evi-icon">
                        <ng-lottie [options]="options"></ng-lottie>
                      </div>
                    </div>
                    <div class="question-heading__content" id="demo-ai-content-heading-1">
                      <h3 class="h5" [innerHTML]="pageInfoSecton('page_header', Status.Conflict)">
                      </h3>
                      <p [innerHTML]="pageInfoSecton('page_text', Status.Conflict)"></p>
                    </div>
                    <div class="question-heading__content d-none" id="demo-ai-content-heading-2">
                      <h3 class="h5" [innerHTML]="pageInfoSecton('page_header', Status.Missing)">
                      </h3>
                      <p [innerHTML]="pageInfoSecton('page_text', Status.Missing)"></p>
                    </div>
                    <div class="question-heading__content d-none" id="demo-ai-content-heading-3">
                      <h3 class="h5" [innerHTML]="pageInfoSecton('page_header', Status.Review)">
                      </h3>
                      <p [innerHTML]="pageInfoSecton('page_text', Status.Review)"></p>
                    </div>
                    <div class="question-heading__content d-none" id="demo-ai-content-heading-4">
                      <h3 class="h5" [innerHTML]="pageInfoSecton('page_header','0')">All sorted!
                      </h3>
                      <p [innerHTML]="pageInfoSecton('page_text','0')"></p>
                    </div>
                  </div>
                  <div class="question">
                    <div class="question-pull">
                      <div class="tile-button-group">

                        @if (questions?.[Status.Conflict]?.length > 0 && conflicting) {
                          <a href="javascript:;" (click)="resetQuestions()"
                            class="tile-button" id="demo-conflicting-info-btn">
                            <div class="tile-button__icon">
                              <svg class="icon">
                                <use xlink:href="#progress"></use>
                              </svg>
                            </div>
                            <div class="tile-button__content">
                              <h5 class="font-16">Conflicting information</h5>
                              <p>
                                We've found some conflicting information in your policy
                                documents and need clarification to proceed
                              </p>
                            </div>
                            <div class="tile-button__tag">
                              <span class="tag-pill tag-pill--warning">To do</span>
                            </div>
                            <div class="tile-button__action">
                              <svg class="icon icon--rotate-270">
                                <use xlink:href="#chevron-down"></use>
                              </svg>
                            </div>
                          </a>
                        }

                        <!-- conflicting info - complete version -->
                        @if (!conflicting) {
                          <a href="javascript:;"
                            class="tile-button is-inactive"
                            id="demo-conflicting-info-btn-complete">
                            <div class="tile-button__icon">
                              <svg class="icon text-color-positive">
                                <use xlink:href="#circle-small-included"></use>
                              </svg>
                            </div>
                            <div class="tile-button__content">
                              <h5 class="font-16">Conflicting information</h5>
                            </div>
                            <div class="tile-button__tag">
                              <span class="tag-pill tag-pill--positive">Complete</span>
                            </div>
                            <div class="tile-button__action">
                              <svg class="icon icon--rotate-270">
                                <use xlink:href="#chevron-down"></use>
                              </svg>
                            </div>
                          </a>
                        }

                        @if (questions?.[Status.Missing]?.length > 0 && missing) {
                          <a href="javascript:;" (click)="resetQuestions()"
                            [ngClass]="step === 2 ? '': 'is-inactive'" class="tile-button"
                            id="demo-missing-info-btn">
                            <div class="tile-button__icon">
                              <svg class="icon">
                                <use xlink:href="#progress"></use>
                              </svg>
                            </div>
                            <div class="tile-button__content">
                              <h5 class="font-16">Missing information</h5>
                              <p>
                                We've found some missing in your policy documents and need
                                clarification to proceed
                              </p>
                            </div>
                            <div class="tile-button__tag">
                              <span class="tag-pill tag-pill--warning">To do</span>
                            </div>
                            <div class="tile-button__action">
                              <svg class="icon icon--rotate-270">
                                <use xlink:href="#chevron-down"></use>
                              </svg>
                            </div>
                          </a>
                        }

                        <!-- missing info - complete version -->
                        @if (!missing) {
                          <a href="#" class="tile-button is-inactive"
                            id="demo-missing-info-btn-complete">
                            <div class="tile-button__icon">
                              <svg class="icon text-color-positive">
                                <use xlink:href="#circle-small-included"></use>
                              </svg>
                            </div>
                            <div class="tile-button__content">
                              <h5 class="font-16">Missing information</h5>
                            </div>
                            <div class="tile-button__tag">
                              <span class="tag-pill tag-pill--positive">Complete</span>
                            </div>
                            <div class="tile-button__action">
                              <svg class="icon icon--rotate-270">
                                <use xlink:href="#chevron-down"></use>
                              </svg>
                            </div>
                          </a>
                        }

                        @if (questions?.[Status.Review]?.length > 0 && step <= 3 ) {
                          <a href="javascript:;" (click)="openReview()"
                            [ngClass]="step === 3 ? '' : 'is-inactive'" class="tile-button"
                            id="demo-review-btn">
                            <div class="tile-button__icon">
                              <svg class="icon">
                                <use xlink:href="#progress"></use>
                              </svg>
                            </div>
                            <div class="tile-button__content">
                              <h5 class="font-16">Review</h5>
                              <p>
                                Confirm that all the details you provided are accurate and
                                that we’ve captured them correctly.
                              </p>
                            </div>
                            <div class="tile-button__tag">
                              <span class="tag-pill tag-pill--warning">To do</span>
                            </div>
                            <div class="tile-button__action">
                              <svg class="icon icon--rotate-270">
                                <use xlink:href="#chevron-down"></use>
                              </svg>
                            </div>
                          </a>
                        }

                        <!-- review - complete version -->
                        @if (step > 3 ) {
                          <a href="javascript:;" (click)="openReview()"
                            class="tile-button" id="demo-review-btn-complete">
                            <div class="tile-button__icon">
                              <svg class="icon text-color-positive">
                                <use xlink:href="#circle-small-included"></use>
                              </svg>
                            </div>
                            <div class="tile-button__content">
                              <h5 class="font-16">Review</h5>
                            </div>
                            <div class="tile-button__tag">
                              <span class="tag-pill tag-pill--positive">Complete</span>
                            </div>
                            <div class="tile-button__action">
                              <svg class="icon icon--rotate-270">
                                <use xlink:href="#chevron-down"></use>
                              </svg>
                            </div>
                          </a>
                        }
                        @if (false) {
                          <a href="javascript:;" class="tile-button"
                            (click)="openAdd()" [ngClass]="step > 3 ? '' : 'is-inactive'"
                            id="demo-add-btn">
                            <div class="tile-button__icon">
                              <svg class="icon">
                                <use xlink:href="#add-items"></use>
                              </svg>
                            </div>
                            <div class="tile-button__content">
                              <h5 class="font-16">Add</h5>
                              <p></p>
                            </div>
                            <div class="tile-button__tag">
                              <span class="tag-pill tag-pill--info">Optional</span>
                            </div>
                            <div class="tile-button__action">
                              <svg class="icon icon--rotate-270">
                                <use xlink:href="#chevron-down"></use>
                              </svg>
                            </div>
                          </a>
                        }


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="ai-modal__content-edit d-none" id="demo-ai-content-edit">


              <!-- items column -->
              <div class="ai-modal__content-items" id="edit-items-col-1">

                <div class="edit-modal__content-wrap" id="demo-conflicting-items-nav">
                  <div class="edit-modal__content-body">
                    <div class="edit-modal__menu">
                      <nav class="edit-nav edit-nav--items">
                        @for (class of classes; track class.class_id) {
                          @if (getQuestions(class?.class_id)?.length > 0 || getItems(class?.class_id)?.length > 0) {
                            <div class="edit-nav__group"
                              >
                              @if (getItems(class?.class_id)?.length > 0) {
                                <div class="edit-nav__title"
                                  >
                                {{class?.product_class}}</div>
                              }
                              <ul>
                                @if (class.class_id === 0) {
                                  @for (item of getItems(class?.class_id,'0'); track item.item_id; let i = $index) {
                                    <li
                                      class="item-trigger"
                                      [ngClass]="{'is-active': isActiveItem(class?.class_id, item?.item_id)}"
                                      id="item-{{class?.class_id}}-{{0}}">
                                      <a href="javascript:;"
                                        (click)="showDiv('item-conflicting-policyholder-details',class.class_id)"
                                        id="conflicting-trigger-{{0}}">
                                        <p><span>Profile</span></p>
                                        @if (getUnAnsweredQuestionCount(class?.class_id,'0') > 0) {
                                          <span
                                            class="tag-pill tag-pill--warning">
                                            {{ step === 3 ? '' : (step === 2 ?
                                            'Required' : 'Conflicting') }}
                                          ({{getUnAnsweredQuestionCount(class?.class_id,'0')}})</span>
                                        }
                                      </a>
                                    </li>
                                  }
                                }
                                @if (class.class_id !== 0) {
                                  @for (item of getItems(class?.class_id); track item.item_id; let i = $index) {
                                    <li
                                      class="item-trigger"
                                      [ngClass]="{'is-active': isActiveItem(class?.class_id, item?.item_id)}"
                                      id="item-{{class?.class_id}}-{{item?.item_id}}">
                                      <a href="javascript:;"
                                        (click)="showDiv('item-conflicting-policyholder-details',class.class_id,item?.item_id)"
                                        id="conflicting-trigger-{{item?.item_id}}">
                                        <p><span>{{item?.description ? item?.description
                                          : 'Not
                                        provided'}}</span></p>
                                        @if (getUnAnsweredQuestionCount(class?.class_id,item?.item_id) > 0) {
                                          <span
                                            class="tag-pill tag-pill--warning">
                                            {{ step === 3 ? '' : (step === 2 ?
                                            'Required' : 'Conflicting') }}
                                          ({{getUnAnsweredQuestionCount(class?.class_id,item?.item_id)}})</span>
                                        }
                                      </a>
                                    </li>
                                  }
                                }
                              </ul>
                            </div>
                          }
                        }

                      </nav>
                    </div>
                  </div>
                </div>

                <div class="edit-modal__content-wrap d-none" id="add-benefits-nav">
                  <div class="edit-modal__content-body">
                    <div class="edit-modal__menu">

                      <nav class="edit-nav edit-nav--items">

                        <div class="edit-nav__group">
                          <ul>
                            <li class="is-active">
                              <a href="javascript:;"
                                onclick="openAIModalItem(event, 'item-policy-benefits')"
                                id="add-trigger-1">
                                <p><span>Policy benefits</span></p>
                              </a>
                            </li>
                            <li>
                              <a href="javascript:;"
                                onclick="openAIModalItem(event, 'item-insured-item-benefits')"
                                id="add-trigger-2">
                                <p><span>Insured item benefits</span></p>
                              </a>
                            </li>
                          </ul>
                        </div>


                      </nav>

                    </div>
                  </div>
                </div>

              </div>

              <!-- item column -->
              <div class="ai-modal__content-item" id="edit-item-col-2">

                <div id="item-empty" class="edit-modal__content-wrap d-none">
                  <div class="edit-modal__content-body" id="item-empty-edit">
                    <div class="edit-modal__empty">
                      <div class="edit-modal__empty-copy">
                        <h4>Select an item to get started</h4>
                        <p>Make all your changes in one go. When you’re done making changes, hit
                          the ‘Review
                        changes’ button.</p>
                      </div>
                      <div class="edit-modal__empty-img">
                        <img src="/assets/img/home/header-shop-personal-greyscale.svg" alt=""
                          class="img-fluid">
                        </div>
                      </div>
                    </div>
                    <div class="edit-modal__content-body d-none" id="item-empty-add">
                      <div class="edit-modal__empty edit-modal__empty--active">
                        <div class="edit-modal__empty-img">
                          <img src="/assets/img/home/category-small-personal-greyscale.svg" alt=""
                            class="img-fluid">
                          </div>
                          <div class="edit-modal__empty-copy">
                            <h3 class="font-semibold">What do you want to do?</h3>
                            <p>Make all your changes in one go. When you’re done making changes,
                            hit the ‘Review changes’ button.</p>
                          </div>
                          <div class="edit-modal__empty-actions">
                            <a href="#" onclick="alert('goes to question flow')">
                              <svg class="icon">
                                <use xlink:href="#insured-items-add"></use>
                              </svg>
                              <div>
                                <h6 class="font-16">Add an item to insure</h6>
                                <p>Make changes or update one of your insured items</p>
                              </div>
                            </a>
                            <a href="/pages/everything.policy-edit-entire.add-benefits.html">
                              <svg class="icon">
                                <use xlink:href="#benefit-add"></use>
                              </svg>
                              <div>
                                <h6 class="font-16">Add a benefit</h6>
                                <p>Make changes or update one of your policy benefits</p>
                              </div>
                            </a>

                          </div>
                        </div>
                      </div>
                      <div class="edit-modal__content-body d-none" id="item-empty-remove">
                        <div class="edit-modal__empty edit-modal__empty--active">
                          <div class="edit-modal__empty-img">
                            <img src="/assets/img/home/category-small-personal-greyscale.svg" alt=""
                              class="img-fluid">
                            </div>
                            <div class="edit-modal__empty-copy">
                              <h3 class="font-semibold">What do you want to do?</h3>
                              <p>Make all your changes in one go. When you’re done making changes,
                              hit the ‘Review changes’ button.</p>
                            </div>
                            <div class="edit-modal__empty-actions">
                              <a href="#remove-insured-select-modal" data-toggle="modal">
                                <svg class="icon">
                                  <use xlink:href="#insured-items-remove"></use>
                                </svg>
                                <div>
                                  <h6 class="font-16">Remove an item</h6>
                                  <p>Make changes or update one of your insured items</p>
                                </div>
                              </a>
                              <a href="#remove-benefit-select-modal" data-toggle="modal">
                                <svg class="icon">
                                  <use xlink:href="#benefit-remove"></use>
                                </svg>
                                <div>
                                  <h6 class="font-16">Remove a benefit</h6>
                                  <p>Make changes or update one of your policy benefits</p>
                                </div>
                              </a>

                            </div>
                          </div>
                        </div>
                        <div class="edit-modal__content-body d-none" id="item-empty-pause">
                          <div class="edit-modal__empty edit-modal__empty--active">
                            <div class="edit-modal__empty-img">
                              <img src="/assets/img/home/category-small-personal-greyscale.svg" alt=""
                                class="img-fluid">
                              </div>
                              <div class="edit-modal__empty-copy">
                                <h3 class="font-semibold">What do you want to do?</h3>
                                <p>Make all your changes in one go. When you’re done making changes,
                                hit the ‘Review changes’ button.</p>
                              </div>
                              <div class="edit-modal__empty-actions">
                                <a href="#" onclick="alert('goes to question flow')">
                                  <svg class="icon">
                                    <use xlink:href="#insured-items-pause"></use>
                                  </svg>
                                  <div>
                                    <h6 class="font-16">Pause an insure item</h6>
                                    <p>Make changes or update one of your insured items</p>
                                  </div>
                                </a>
                                <a href="/pages/everything.policy-edit-entire-benefits.html">
                                  <svg class="icon">
                                    <use xlink:href="#benefit-pause"></use>
                                  </svg>
                                  <div>
                                    <h6 class="font-16">Pause a benefit</h6>
                                    <p>Make changes or update one of your policy benefits</p>
                                  </div>
                                </a>

                              </div>
                            </div>
                          </div>
                        </div>

                        <div id="item-conflicting-policyholder-details" class="edit-modal__content-wrap d-none">
                          <div class="edit-modal__content-body">
                            <div class="p-20">

                              <div class="edit-modal__content-body-contain">

                                <div class="notice notice--evi-lg mb-30">
                                  <div class="notice__inner">
                                    <div class="notice__content">

                                      <div class="evi-icon evi-icon--xl">
                                        <ng-lottie [options]="options"></ng-lottie>
                                      </div>

                                      <p><strong>Let's fix the conflicts</strong><br></p>
                                    </div>
                                    <div class="notice__tray">
                                      <a href="javascript:;" (click)="initEvi()?.eviExpand()"
                                        class="button button--evi button--md"
                                      data-trigger="evi">Chat to me</a>
                                    </div>
                                  </div>
                                </div>
                                @if (step === 3) {
                                  <div class="summary-card">
                                    <div class="summary-card__header">
                                      @if (itemQuestions?.length > 0) {
                                        <div
                                          class="summary-card__header-title">
                                          <h3>{{itemQuestions[0]?.description ?
                                            itemQuestions[0]?.description : 'Not provided'
                                            }}
                                          </h3>
                                          <p></p>
                                        </div>
                                      }
                                    </div>
                                    <div class="summary-card__actions">
                                      <a href="#remove-modal" data-toggle="modal"
                                        class="action-icon action-icon--transparent">
                                        <div class="action-icon__icon">
                                          <svg class="icon">
                                            <use xlink:href="#trash-bin"></use>
                                          </svg>
                                        </div>
                                        <small class="action-icon__label">Remove</small>
                                      </a>
                                    </div>
                                  </div>
                                }
                                @if (itemQuestions?.length > 0) {
                                  @for (question of itemQuestions; track question.cent_aq_question_id) {
                                    <div
                                      class="card card--edit-modal card--edit-modal--outstanding"
                                      id="demo-conflicting-item-{{question?.cent_aq_question_id}}">
                                      <div class="card-body">
                                        <div class="card__content">
                                          <div class="card__header">
                                            <div class="card__header-title">
                                              <h5>{{question?.email_version}}</h5>
                                            </div>
                                          </div>
                                          <app-question-controller [question]="question"
                                            [showLabel]="false" [showParent]="false"
                                            [isEditModal]="false" [readOnly]="false"
                                            [showLabelEmailVersion]="true"
                                            [evi]="true"
                                            (questionAnswer)="onQuestionAnswerChange($event)"
                                            [controlCssClass]="' '">
                                          </app-question-controller>
                                        </div>
                                        @if (question?.itk) {
                                          <app-itk [content]="question?.itk"></app-itk>
                                          }
                                          @if (!question?.answer) {
                                            <div class="card__tray">
                                              <div class="card__tray-note">
                                                <svg class="icon">
                                                  <use xlink:href="#warning"></use>
                                                </svg>
                                                <div class="card__tray-note-content">
                                                  <h6 class="mb-2">
                                                    {{question?.extraction_details?.message}}
                                                  </h6>
                                                  <p><small>{{question?.extraction_details?.itk}}</small>
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        }
                                        <!-- Dependent flow -->
                                        @if (question?.dependant_flow_id && activeDependentQuestionId === question?.cent_aq_question_id && (dependentFlowActive || dependentFlowDone)) {
                                          <div
                                            class="card__additional">
                                            <!-- Questions panel -->
                                            @if (dependentFlowActive) {
                                              <div
                                                class="card__additional-inner card__content">
                                                <div class="card__header">
                                                  <div class="card__header-title">
                                                    <h5>{{currentQuestion?.email_version}}</h5>
                                                  </div>
                                                </div>
                                                <div class="form-group">
                                                  <app-question-controller
                                                    [question]="currentQuestion"
                                                    [showLabel]="false" [showParent]="false"
                                                    [isEditModal]="true" [readOnly]="false"
                                                    [childItemQuestions]="getChildrenQuestions(currentQuestion)"
                                                    [showLabelEmailVersion]="false"
                                                    (questionAnswer)="subQuestionResponse($event)">
                                                  </app-question-controller>
                                                </div>
                                                @if (itk) {
                                                  <aside class="question-fyi">
                                                    <div class="question-fyi__icon">
                                                      <img src="assets/0/icn/message-avatar.svg"
                                                        class="icon">
                                                      </div>
                                                      <div class="question-fyi__content">
                                                        <h6>Important to know</h6>
                                                        <p [innerHTML]="itk"></p>
                                                      </div>
                                                    </aside>
                                                  }
                                                  <div class="card__additional-nav">
                                                    @if (currentQuestion?.flow_index === 1 && currentQuestion?.next) {
                                                      <a href="javascript:;"  class="button button--no-min button--naked" (click)="resetQuestion(); ">Cancel</a>
                                                    }
                                                    @if (!(currentQuestion?.flow_index === 1) || !currentQuestion?.next) {
                                                      <a href="javascript:;"
                                                        (click)="prevDependentQuestion()"
                                                      class="button button--no-min button--naked">Back</a>
                                                    }
                                                    @if (currentQuestion?.next) {
                                                      <button (click)="nextDependentQuestion()"
                                                        class="button button--primary"
                                                        [ngClass]="{'button--loading': processing}"
                                                        [disabled]="processing">
                                                        @if (processing) {
                                                          <span
                                                            class="button__spinner"><span
                                                          class="spinner"></span></span>
                                                        }
                                                        Continue
                                                      </button>
                                                    }
                                                    @if (!currentQuestion?.next) {
                                                      <button (click)="dependantFlowDone()"
                                                        class="button button--primary"
                                                        [ngClass]="{'button--loading': processing}"
                                                        [disabled]="processing">
                                                        @if (processing) {
                                                          <span
                                                            class="button__spinner"><span
                                                          class="spinner"></span></span>
                                                        }
                                                        Done
                                                      </button>
                                                    }
                                                  </div>
                                                </div>
                                              }
                                              <!-- Summary panel -->
                                              @if (dependentFlowDone) {
                                                <div
                                                  class="card__additional-wrap">
                                                  <div class="card__additional-summary">
                                                    @for (answeredQuestion of answeredQuestions; track answeredQuestion.cent_aq_question_id) {
                                                      <div class="card__additional-summary-control"
                                                        >
                                                        <div class="card__header">
                                                          <div class="card__header-title">
                                                            <h5>{{answeredQuestion?.email_version}}
                                                            </h5>
                                                          </div>
                                                        </div>
                                                        <div class="form-group">
                                                          <app-question-controller
                                                            [question]="answeredQuestion"
                                                            [showLabel]="false"
                                                            [showParent]="false"
                                                            [isEditModal]="true"
                                                            [readOnly]="false"
                                                            [childItemQuestions]="getChildrenQuestions(answeredQuestion)"
                                                            [showLabelEmailVersion]="false">
                                                          </app-question-controller>
                                                        </div>
                                                      </div>
                                                    }
                                                  </div>
                                                  <div class="card__additional-nav">
                                                    <a href="javascript:;"
                                                      (click)="restartDependentFlow()"
                                                      class="button button--no-min button--naked">Edit
                                                    answers</a>
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                          }
                                          <!-- /Dependent flow -->
                                        </div>
                                      </div>
                                    }
                                  }

                                </div>

                              </div>
                            </div>
                          </div>



                        </div>

                        <!-- <app-question-flow-controller></app-question-flow-controller> -->
                      </div>


                    </div>
                    <div class="ai-modal__tray">
                      <div class="ai-modal__tray-btns">
                        <a href="javascript:;" (click)="continue()" class="button button--primary"
                          [attr.disabled]="modalButton.disabled ? true : null">{{modalButton.text}}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="ai-modal__close" (click)="dismissAIModal()">
              <svg class="icon">
                <use xlink:href="#close-medium"></use>
              </svg>
            </div>
            <div class="ai-modal__backdrop" (click)="dismissAIModal()"></div>
          </div>
          <div class="modal fade modal--alert" id="evi-modal-additional" tabindex="-1" role="dialog"
            aria-labelledby="evi-modal-additional" aria-modal="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content modal-alert modal-alert--alt">
                <div class="modal-alert__heading">
                  <div class="container">
                    <button class="modal-alert__close" (click)="cancelDependentFlow()" data-dismiss="modal">
                      <svg class="icon">
                        <use xlink:href="#close-medium"></use>
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="modal-alert__content">
                  <div class="container">
                    <div class="rte">
                      <h3>Changing this answer may require additional questions.</h3>
                      <p>Note that changes may affect your quote. All previously answered questions that don't require
                      changes will still be saved.</p>
                    </div>
                  </div>
                </div>
                <div class="modal-alert__button">
                  <div class="container">
                    <a href="javascript:;" class="button button--lg button--secondary" (click)="cancelDependentFlow()"
                    data-dismiss="modal">Cancel</a>
                    <a href="javascript:;" class="button button--lg button--primary"
                    (click)="confirmStartDependentFlow()" data-dismiss="modal">Got it</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade modal--mini" id="exit-modal" tabindex="-1" role="dialog" aria-labelledby="exit-modal"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content modal-mini">
                <div class="modal-mini__heading">
                  <div class="container-fluid">
                    <h4>Are you sure you want to exit?</h4>
                  </div>
                </div>

                <div class="modal-mini__content">
                  <div class="container-fluid">
                    <div class="rte">
                      <p>By leaving now, all of your changes to this [item/benefit] will be discarded. Once gone,
                        these changes
                      will not be recoverable.</p>

                      <p>Are you sure you want to continue?</p>
                    </div>
                  </div>
                </div>

                <div class="modal-mini__button">
                  <div class="container-fluid">
                    <a href="#" data-dismiss="modal" class="button button--secondary"
                    id="discard-changes-demo-btn">Discard changes</a>
                    <a href="#" data-dismiss="modal" class="button button--primary">Go back</a>
                  </div>
                </div>
              </div>
            </div>
          </div>